import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import Registration from "./components/registration";
import ContentDownload from "./components/contentDownload";
import Home from "./components/home";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Router>
      <Routes>
      <Route path="/" element={<App />} />
      <Route path="/home" element={<Home />} />
      {/* <Route path="/registration" element={<Registration />} /> */}
      <Route path="/content-download" element={<ContentDownload />} />
      </Routes>
    </Router>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
